/* eslint-disable no-nested-ternary */
import React, { useState, useRef, useEffect } from "react";
import intl from "react-intl-universal";
import { Button, Form, Input, message } from "antd";
import { sendPwdCode, resetPwd, sendPwdEmailCode } from "@/api/login";
import { getUrlParams } from "@/utils";

import logoImg from "@/assets/image/logo.png";
import styles from "./Password.module.scss";

type FieldType = {
  mobile?: string;
  email?: string;
  password?: string;
  emailVerifyCode?: string;
};

const Password = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState(60);
  const [type, setType] = useState("email");

  const buttonTime = useRef(null);

  useEffect(() => {
    // setType(getUrlParams("type") || "mobile");
  }, []);

  if (time === 0) {
    clearInterval(buttonTime.current);
    buttonTime.current = null;
    setTime(60);
  }

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const res = await resetPwd({ ...values });
      if (res.code === 200) {
        message.success(intl.get("password_changeSuccess"));
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      }
    } finally {
      setLoading(false);
    }
  };

  const sendEmail = async (email) => {
    setLoading(true);
    try {
      const res = await sendPwdEmailCode({ email });
      if (res.code === 200) {
        message.success(intl.get("password_sendSuccess"));
        buttonTime.current = setInterval(() => {
          setTime((prevCount) => prevCount - 1);
        }, 1000);
      }
    } finally {
      setLoading(false);
    }
  };

  const sendMobile = async (mobile) => {
    setLoading(true);
    try {
      const res = await sendPwdCode({ mobile });
      if (res.code === 200) {
        message.success(intl.get("password_sendSuccess"));
        buttonTime.current = setInterval(() => {
          setTime((prevCount) => prevCount - 1);
        }, 1000);
      }
    } finally {
      setLoading(false);
    }
  };

  const validatorPassword = (_rule, value) => {
    if (!value) {
      return Promise.reject(new Error(intl.get("password_enterPassword")));
    }
    // const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*(\d|[\W_])).{8,16}$/;
    const hasLowercase = /[a-z]/.test(value);
    const hasUppercase = /[A-Z]/.test(value);
    const hasDigit = /\d/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>+]/.test(value);

    const characterTypesCount = [
      hasLowercase,
      hasUppercase,
      hasDigit,
      hasSpecialChar,
    ].filter(Boolean).length;

    if (characterTypesCount < 3 || value.length < 8 || value.length > 16) {
      return Promise.reject(new Error(intl.get("password_requirements")));
    }
    return Promise.resolve();
  };

  return (
    <>
      <div className={styles.content}>
        <div className={styles.contentForm}>
          <div className={styles.title}>
            <img src={logoImg} alt="" />
            {intl.get("password_recover")}
          </div>

          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            onFinish={onFinish}
            layout="vertical"
            autoComplete="off"
            form={form}
          >
            {type === "mobile" && (
              <>
                <Form.Item<FieldType>
                  name="mobile"
                  label={intl.get("registry_phone")}
                  rules={[
                    {
                      required: true,
                      message: intl.get("registry_inputPhone"),
                    },
                  ]}
                >
                  <Input
                    className={styles.addonBeforeLoginIuput}
                    placeholder={intl.get("registry_inputPhone")}
                    readOnly={loading}
                    allowClear
                    addonBefore="+86"
                  />
                </Form.Item>
                <Form.Item<FieldType>
                  name="emailVerifyCode"
                  label={intl.get("password_verificationCode")}
                  rules={[
                    {
                      required: true,
                      message: intl.get("password_inputVerificationCode"),
                    },
                  ]}
                >
                  <div className={styles.loginIuputCode}>
                    <Input
                      className={`${styles.loginIuput}`}
                      placeholder={intl.get("password_inputVerificationCode")}
                      readOnly={loading}
                      allowClear
                    />
                    <Button
                      className={styles.loginIuputBtn}
                      type="link"
                      loading={loading}
                      disabled={buttonTime.current}
                      onClick={() => {
                        if (!form.getFieldValue("mobile")) {
                          return message.error(
                            intl.get("password_emailRequired"),
                          );
                        }
                        sendMobile(form.getFieldValue("mobile"));
                      }}
                    >
                      {buttonTime.current
                        ? `${time}s`
                        : intl.get("password_getVerificationCode")}
                    </Button>
                  </div>
                </Form.Item>
              </>
            )}
            {type === "email" && (
              <>
                <Form.Item<FieldType>
                  name="email"
                  label={intl.get("password_email")}
                  rules={[
                    {
                      required: true,
                      message: intl.get("password_inputEmail"),
                    },
                  ]}
                >
                  <Input
                    className={styles.loginIuput}
                    placeholder={intl.get("password_inputEmail")}
                    readOnly={loading}
                    allowClear
                  />
                </Form.Item>

                <Form.Item<FieldType>
                  name="emailVerifyCode"
                  label={intl.get("password_verificationEmailCode")}
                  rules={[
                    {
                      required: true,
                      message: intl.get("password_inputVerificationEmailCode"),
                    },
                  ]}
                >
                  <div className={styles.loginIuputCode}>
                    <Input
                      className={`${styles.loginIuput}`}
                      placeholder={intl.get(
                        "password_inputVerificationEmailCode",
                      )}
                      readOnly={loading}
                      allowClear
                    />
                    <Button
                      className={styles.loginIuputBtn}
                      type="link"
                      loading={loading}
                      disabled={buttonTime.current}
                      onClick={() => {
                        if (!form.getFieldValue("email")) {
                          return message.error(
                            intl.get("password_inputVerificationEmailCode"),
                          );
                        }
                        sendEmail(form.getFieldValue("email"));
                      }}
                    >
                      {buttonTime.current
                        ? `${time}s`
                        : intl.get("password_getVerificationCode")}
                    </Button>
                  </div>
                </Form.Item>
              </>
            )}

            <Form.Item<FieldType>
              name="password"
              label={intl.get("password_newpassword")}
              rules={[
                {
                  required: true,
                  validator: validatorPassword,
                },
              ]}
              style={{ marginBottom: 0 }}
            >
              <div>
                <Input.Password
                  className={styles.loginIuput}
                  placeholder={intl.get("password_inputNewPassword")}
                  readOnly={loading}
                  allowClear
                />
                <p className={styles.pwdTips}>
                  {intl.get("password_requirements")}
                </p>
              </div>
            </Form.Item>

            <div className={styles.wjPwdButton}>
              <Button
                type="link"
                onClick={() => {
                  window.location.href = `/login${window.location.search}`;
                }}
              >
                {intl.get("registry_goLogin")}
              </Button>
            </div>
            <Button
              className={styles.loginButton}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              {intl.get("password_confirm")}
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Password;
